import React from 'react';
import { Typography } from '@mui/material';

/** Names a group of controls in the layout dialogs. */
const SectionLabel = function SectionLabel({ children }) {
  return (
    <Typography variant="overline" sx={{ opacity: '60%' }}>
      {children}
    </Typography>
  );
};

export default SectionLabel;
